import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { UPDATE_DMX_CONTROLLER } from './actionTypes';
import { updateDmxControllerSuccessful, updateDmxControllerFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* updateController({ payload: { controller } }) {
  try {
    const response = yield call(dmxAPI.updateController, controller.token, controller.id, controller);
    if (response.message) {
      yield put(updateDmxControllerSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(updateDmxControllerFailed(error));
  }
}

export function* watchUpdateDmxController() {
  yield takeEvery(UPDATE_DMX_CONTROLLER, updateController);
}

function* updateDmxControllerSaga() {
  yield all([fork(watchUpdateDmxController)]);
}

export default updateDmxControllerSaga;
